import { checkNestedObject } from "utils/checkNestedObject";

export const checkIfGuestFlow = ({ state }) => checkNestedObject(state, "isGuestFlow");
